export default __webpack_public_path__ + "static/media/use_action_back_zc.ca0161e6.png";